import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setSilAssumptionBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.SIL_ASSUMPTION_BASE_ROUTE),
    baseRoute,
})
export const setSilAssumptionReloadView = (value: boolean) => ({
    type: inferLiteral(types.SIL_ASSUMPTION_RELOAD_VIEW),
    value,
})
